module.exports = __webpack_public_path__ + "img/Info.91201d53.png";